// src/components/profiles/GuestUser/components/moments/GuestMomentsSection.tsx

"use client";

import React from "react";

import GuestMomentMyGrid from "./GuestMomentMyGrid";

import "./GuestMomentsSection.css";

const GuestMomentsSection: React.FC = () => {
  return (
    <section className="guest-moments-section" aria-label="Guest moments section">
      <GuestMomentMyGrid />
    </section>
  );
};

export default GuestMomentsSection;